import React from 'react'
import { TranslationProvider } from '~/components/shared/TranslationProvider'
import { SavedCoursesProvider } from './SavedCoursesProvider'
import translations from '../locales.json'
import Page from './Page'
import { Toaster } from '~/lib/ui/toast'
import { FiltersProvider } from '~/components/shared/useFilters'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient()

const SavedCoursesPage = ({ locale, ...props }) => {
  const filterValues = ['reminder_created', 'completed', 'saved', 'started']
  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope="javascript.components.ResearchLearning.SavedCoursesPage"
    >
      <QueryClientProvider client={queryClient}>
        <SavedCoursesProvider {...props}>
          <FiltersProvider filterValues={filterValues}>
            <Toaster />
            <div className="fix-legacy-hack flex flex-col border-l border-alto-200">
              <div className="max-md:p-2 md:px-[2.5rem] md:py-[2.5rem]">
                <Page />
              </div>
            </div>
          </FiltersProvider>
        </SavedCoursesProvider>
      </QueryClientProvider>
    </TranslationProvider>
  )
}
export default SavedCoursesPage
